var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('spinner',{staticClass:"d-block mx-auto",attrs:{"size":30}}):_c('p',{staticClass:"text-center mt-4"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }